import { Component, ViewEncapsulation } from '@angular/core';
import { BaseView } from '../base-view/base-view.directive';
import { DragDropDirective } from '../../directives/drag-drop.directive';
import { NgClass, CommonModule } from '@angular/common';
import {TablerIconsModule} from 'angular-tabler-icons';
import { TranslateModule } from '@ngx-translate/core';
import { CdkDragHandle, CdkDrag, CdkDropList, CdkDragPreview, CdkDragPlaceholder } from '@angular/cdk/drag-drop';

@Component({
    selector: 'nxe-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        DragDropDirective, 
        NgClass, 
        CommonModule, 
        TablerIconsModule,
        TranslateModule,
        CdkDragHandle,
        CdkDrag,      // Importa CdkDrag direttamente
        CdkDropList,  // Importa CdkDropList direttamente
        CdkDragPreview,
        CdkDragPlaceholder,
    ],
})
export class ListComponent extends BaseView {
    public readonly icons = {
        node: 'nxe-folder',
        leaf: 'nxe-doc',
    };

    constructor() {
        super();
    }
}
